import React, { useEffect, useState } from "react";
import styles from "./reservationclean.module.css";
import { Button, Radio, RadioGroup } from "@mui/joy";
import totalLocationData from "../../data/locationdata";
import { postFetch } from "../../fetch/fetch";
import { IonButton, useIonToast } from '@ionic/react';

const ReservationClean: React.FC<any> = (props: any) => {

    const [selectedLocation, setSelectedLocation] = useState<string | null>(null);
    const [selectedDay, setSelectedDay] = useState<string | null>(null);
    const [isDirect, setIsDirect] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [present] = useIonToast();

    const submit = async () => {

        try {

            if (!selectedLocation) {
                alert("지점을 선택해주세요");
                return;
            }

            if (!selectedDay) {
                alert("요일을 선택해주세요");
                return;
            }

            const data = {
                selectedLocation,
                selectedDay,
                isDirect
            }

            console.log(data);

            setLoading(true);

            const result: any = await postFetch("/dashboard/report/reserveclean", data);

            if (result.message === "success") {
                setLoading(false);

                present({
                    message: '성공적으로 전송되었습니다!',
                    duration: 1500,
                    position: "top",
                    color: "success"
                });
            }


        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div>
            <div className={styles.mainDiv}>
                <div className={styles.title}>
                    지점 시설 점검 예약
                </div>
                <div className={styles.questionDiv}>
                    <div className={styles.questionTitle}>
                        이번주에 방문할 지점을 선택해주세요
                    </div>
                    <div className={styles.questionSelect}>
                        <RadioGroup value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)}
                        >
                            {
                                totalLocationData.map((location, index) => {

                                    if (location.english === "total") {
                                        return;
                                    }

                                    const locationAcademy = location.academy[0];

                                    if (!locationAcademy) {
                                        return;
                                    }

                                    if (!locationAcademy.includes("sunbae")) {
                                        return;
                                    }

                                    return (
                                        <Radio value={location.english}
                                            key={index} label={location.korean}
                                        />
                                    )
                                })
                            }
                        </RadioGroup>
                    </div>
                </div>
                {/* 이번주 방문 요일  월-일 */}
                <div className={styles.questionDiv}>
                    <div className={styles.questionTitle}>
                        이번주에 방문할 요일을 선택해주세요
                    </div>
                    <div className={styles.questionSelect} style={{
                        marginTop: "15px"
                    }}>
                        <RadioGroup value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}
                        >
                            {
                                new Array(7).fill(undefined).map((day, index) => {
                                    return (
                                        <Radio value={index}
                                            key={index} label={
                                                `${["일", "월", "화", "수", "목", "금", "토"][index]}요일`
                                            } />
                                    )
                                })
                            }
                        </RadioGroup>
                    </div>
                </div>

                {/* 이번주 방문 요일  월-일 */}
                <div className={styles.questionDiv}>
                    <div className={styles.questionTitle}>
                        이번주에 직접 방문하실 건가요?
                    </div>
                    <div className={styles.questionSelect} style={{
                        marginTop: "15px"
                    }}>
                        <RadioGroup value={isDirect} onChange={(e) => setIsDirect(e.target.value === "true")}
                        >
                            <Radio value="true" label="직접 방문" />
                            <Radio value="false" label="알바가 방문" />
                        </RadioGroup>
                    </div>
                </div>

                <Button
                    fullWidth
                    variant="solid"
                    color="primary"
                    loading={loading}
                    disabled={(!selectedLocation || !selectedDay) || loading}
                    onClick={submit}
                >
                    제출하기
                </Button>
            </div>
        </div>
    )

}

export default ReservationClean;